import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as moment from "moment";
import {
  changeLibraryModal,
  resetActiveFileSettings,
  requestSettingsAddPassword,
  requestSettingsRemovePassword,
} from "../../../../../redux/actions/library";
import { sendErrorNotification } from "../../../../universal/notifications/notifications";
import { TransparentButton, SolidButton } from "../../../../library/button";
import { Input } from "../../../../library/input";
import { Popup } from "../../../../library/popup";
import { Label } from "../../../../library/label";
import { ToastContainer } from "react-toastify";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();
  const modalState = useSelector(
    (state) => state.library.showModals.settingsModal
  );
  const companyId = useSelector(
    (state) => state.activeCompany.activeCompany.id
  );
  const settingsInfo = useSelector((state) => state.library.activeFileSettings);

  const [changePasswordOne, setPasswordOne] = useState("");
  const [changePasswordTwo, setPasswordTwo] = useState("");

  const formatted_date = (timestamp) => {
    return moment(timestamp * 1000).format("HH:MM DD/MM/YYYY");
  };

  const handleClose = () => {
    dispatch(changeLibraryModal({ settingsModal: false }));
    dispatch(resetActiveFileSettings());
    setPasswordOne("");
    setPasswordTwo("");
  };

  const clickUpdateFilePassword = () => {
    if (settingsInfo.password) {
      if (changePasswordOne === changePasswordTwo) {
        dispatch(
          requestSettingsRemovePassword({
            companyId: companyId,
            info: settingsInfo,
            password: changePasswordOne,
          })
        );
      } else {
        sendErrorNotification("Passordene du oppga er ikke like.");
      }
    } else {
      if (changePasswordOne.length > 5 && changePasswordTwo.length > 5) {
        if (changePasswordOne === changePasswordTwo) {
          dispatch(
            requestSettingsAddPassword({
              companyId: companyId,
              info: settingsInfo,
              password: changePasswordOne,
            })
          );
        } else {
          sendErrorNotification("Passordene du oppga er ikke like.");
        }
      } else {
        sendErrorNotification("Passordet ditt må være lenger enn 5 bokstaver.");
      }
    }
  };

  const determinePasswordType = () => {
    if (settingsInfo) {
      if (settingsInfo.password) {
        return "Fjern passord";
      } else {
        return "Sett passord";
      }
    }
  };

  return (
    <Popup
      onClose={handleClose}
      show={modalState}
      title="Innstillinger for fil"
      buttons={[
        <TransparentButton
          title="Avbryt"
          type="button"
          data-dismiss="modal"
          onClick={() => handleClose()}
        />,
        <SolidButton
          color="blue"
          title={determinePasswordType()}
          icon={<i className="fas fa-lock"></i>}
          onClick={() =>
            clickUpdateFilePassword(settingsInfo ? settingsInfo.password : null)
          }
          type="button"
        />,
      ]}
    >
      <div className="library-settings-content-container">
        <div className="file-full-info-container">
          <div className="file-container">
            <h1 className="file-icon">
              <i className="far fa-file-image"></i>
            </h1>
            <h3 className="file-name">
              {settingsInfo ? settingsInfo.name : "Undefined"}
            </h3>
            <p className="file-size">
              Lastet opp{" "}
              {settingsInfo ? formatted_date(settingsInfo.date) : "Undefined"}
            </p>
          </div>
        </div>
        <div className="file-settings-container">
          <Row className="password-row">
            <Col md={6} className="text-left">
              <Label version={1} weight="bold">
                Passord
              </Label>
              <Input
                onChange={(e) => setPasswordOne(e.target.value)}
                value={changePasswordOne}
                type="password"
                placeholder="Passord"
              />
            </Col>
            <Col md={6} className="text-left">
              <Label version={1} weight="bold">
                Gjenta passord
              </Label>
              <Input
                onChange={(e) => setPasswordTwo(e.target.value)}
                value={changePasswordTwo}
                type="password"
                placeholder="Passord"
              />
            </Col>
          </Row>
        </div>
      </div>
      <ToastContainer />
    </Popup>
  );
};

export default Index;
